module.exports = __webpack_public_path__ + "static/media/MaisonNeue-Demi.c82c5d71.woff2";